var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[_c('b-container',{attrs:{"id":"page-container","fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }